import { LegacyEventEmitter } from 'expo-modules-core';

import ExpoLocation from './ExpoLocation';

export const LocationEventEmitter = new LegacyEventEmitter(ExpoLocation);
